// JavaScript source code
import './styles/AccountMenu.css';
import { useLayoutEffect, useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import { Navigate } from 'react-router-dom';
import { GetAccessToken, FetchAccountInfo } from "./Utilities";
import webContentStrings from "./ContentStrings/LocalizedStrings.js";

function AccountMenu({ status, setStatus, collapsed }) {
    const [size, setSize] = useState([0, 0]);
    const [hovered, setHovered] = useState(false);
    const [logout, setLogout] = useState(false);
    const [accountName, setAccountName] = useState("");

    useLayoutEffect(() => {

        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }

        window.addEventListener('resize', updateSize);
        updateSize();
    }, []);

    useEffect(() => {
        FetchAccountInfo(setAccountName);
    }, [status]);

    function SignOut() {

        if (Cookies.get("LudareRefreshToken") === undefined) return;

        GetAccessToken().then((token) => { 

            const reqOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 'RefreshToken': Cookies.get("LudareRefreshToken"), 'AccessToken': token })
            };

            fetch(process.env.REACT_APP_NODE_ADDRESS + '/Logout', reqOptions)
                .then((res) => res.json())
                .then((data) => {
                    Cookies.remove("LudareAccessToken");
                    Cookies.remove("LudareRefreshToken");
                    setStatus(false);
                });
        });
    };

    return (
        <div className="accountWrapper">
            {collapsed !== true &&
                <div className="accountMenuParent">

                    {status !== true && <div>
                        <a className="signInMenu" href='/login' >{webContentStrings.headerStrings.signIn}</a>
                    </div>}
                    {status === true && <div
                        onMouseEnter={() => setHovered(true)}
                        onMouseLeave={() => setHovered(false)}
                    >
                        <a className="accountMenu" href='/account'>{accountName.Username}</a>
                        {hovered && <ul className="accountDropdown">
                            {status === true && <li className="libraryItem"><a className="libraryAccess" href='/account/subscription'>{webContentStrings.headerStrings.subscription}</a></li>}
                            {status === true && <li className="menuBreak"><hr className="accountBreak" /></li>}
                            {status === true && <li className="libraryItem"><a className="libraryAccess" href='/GameDownloads'>{webContentStrings.headerStrings.downloads}</a></li>}
                            <li className="menuBreak"><hr className="accountBreak" /></li>
                            <li className="signOut" ><a className="signOutExpanded" onClick={SignOut}>{webContentStrings.headerStrings.signOut}</a></li>
                        </ul>}
                    </div>}
                </div>
            }
            {collapsed === true &&
                <div className="accountMenuParent">

                    {status !== true && <div>
                        <a className="signInMenuCollapsed" href='/login'>{webContentStrings.headerStrings.signIn}</a>
                    </div>}
                    {status === true && <ul className="accountDropdown">
                        <li><a className="libraryAccess" href='/GameDownloads'>{webContentStrings.headerStrings.downloads}</a></li>
                        <li><hr className="accountBreak" /></li>
                        <li className="libraryItem"><a className="libraryAccess" href='/account/subscription'>{webContentStrings.headerStrings.subscription}</a></li>
                        <li><hr className="accountBreak" /></li>
                        <li className="signOutCollapsed" ><a className="signOutExpanded" onClick={SignOut}>{webContentStrings.headerStrings.signOut}</a></li>
                    </ul>}
                </div>
            }
        </div>
    );
}

export default AccountMenu;
